import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import RichtextEditor from '../../../../Core/TextEditor/RichtextEditor'
const Tab1 = ({ brand, setBrand, description, brandName, setDescription, activityboll }) => {
  const status = 'no'
  const [content, setContent] = useState('');
  const [showActivity, setShowActivity] = useState(true);
  return (
    <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                 <Input
              id="BrandName"
              label="Brand Name"
              style={{ height: "30px" }}
              readOnly
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1, height: '23px' }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}></p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                <RichtextEditor content={description} setContent={setContent} isEditable={false} />

                </div>

              </div>


            </div>
          </div>

             <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
            <ActivityCard doctype="Brand" docname={brandName} />
            </div>
          </div>
        </div>
        </div>
      </div>

    </div>
  )
}

export default Tab1